export const S3CLOUD_CLOUDFRONT = 'https://asset.weavebliss.com/'
export const S3CLOUD_CLOUDFRONT_ETSY = S3CLOUD_CLOUDFRONT + 'etsy/'
export const S3CLOUD_CLOUDFRONT_ASSET = S3CLOUD_CLOUDFRONT + 'assets/'
export const S3CLOUD_CLOUDFRONT_ASSET_HEADER = S3CLOUD_CLOUDFRONT + 'assets/header/'
export const S3CLOUD_CLOUDFRONT_USERLOGIN = S3CLOUD_CLOUDFRONT + 'assets/userlogin/'
